// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_6989e3f"};